import PropTypes from 'prop-types';
export const searchResultsProductsPropTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    href: PropTypes.string,
    picture: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string
    }),
    labels: PropTypes.arrayOf(PropTypes.string),
    vendor: PropTypes.string,
    title: PropTypes.string,
    price: PropTypes.shape({
      regular: PropTypes.number,
      sale: PropTypes.number,
      currency: PropTypes.string
    })
  })),
  button: PropTypes.shape({
    label: PropTypes.string,
    href: PropTypes.string
  })
};